import React from 'react';
import SectionForm from '../Section.Form';
import SectionOurServices from '../Section.OurServices';
import SectionTestimonials from '../Section.Testimonials';
import SectionChooseUs from '../Section.ChooseUs';
import { Helmet }from 'react-helmet'

const Home = () => {
  return (
    <>
      <Helmet>
        <title>I'm Your Huckleberry | Home</title>
      </Helmet>
      <SectionForm />
      <SectionOurServices />
      <SectionChooseUs />
      <SectionTestimonials />
    </>
  );
};

export default Home;
